export default __webpack_public_path__ + "static/media/statusNegativeNoBorder.4deaff9a.svg";